import React from "react";
import { X, UserCheck, Users, ShieldCheck } from "lucide-react";
import "./RoleSwitchConfirmationModal.css";

const RoleSwitchConfirmationModal = ({
  visible,
  onClose,
  currentRole,
  targetRole,
  onConfirm,
  isLoading = false,
}) => {
  if (!visible) return null;

  const getRoleIcon = (role) => {
    switch (role) {
      case "host":
        return <UserCheck size={48} />;
      case "usher":
        return <ShieldCheck size={48} />;
      case "guest":
        return <Users size={48} />;
      default:
        return <UserCheck size={48} />;
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case "host":
        return "#006615";
      case "usher":
        return "#006615";
      case "guest":
        return "#006615";
      default:
        return "#006615";
    }
  };

  const getRoleDisplayName = (role) => {
    return role.charAt(0).toUpperCase() + role.slice(1);
  };

  const getRoleDescription = (role) => {
    switch (role) {
      case "host":
        return "Create and manage events, invite guests, and oversee all event activities.";
      case "usher":
        return "Check-in guests, scan QR codes, and assist with event management.";
      case "guest":
        return "Discover events, RSVP, and interact with event hosts.";
      default:
        return "";
    }
  };

  return (
    <div className="role-switch-modal-overlay" onClick={onClose}>
      <div
        className="role-switch-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="role-switch-close-button" onClick={onClose}>
          <X size={24} />
        </button>

        <div
          className="role-switch-icon-container"
          style={{ backgroundColor: `${getRoleColor(targetRole)}15` }}
        >
          <div style={{ color: getRoleColor(targetRole) }}>
            {getRoleIcon(targetRole)}
          </div>
        </div>

        <h2 className="role-switch-title">
          Switch to {getRoleDisplayName(targetRole)}?
        </h2>

        <div className="role-switch-info-card">
          <div className="role-switch-info-label">Current Role</div>
          <div className="role-switch-info-value">
            {getRoleDisplayName(currentRole)}
          </div>
        </div>

        <div className="role-switch-arrow">↓</div>

        <div
          className="role-switch-info-card role-switch-target"
          style={{ borderColor: getRoleColor(targetRole) }}
        >
          <div className="role-switch-info-label">New Role</div>
          <div
            className="role-switch-info-value"
            style={{ color: getRoleColor(targetRole) }}
          >
            {getRoleDisplayName(targetRole)}
          </div>
        </div>

        <p className="role-switch-description">
          {getRoleDescription(targetRole)}
        </p>

        <div className="role-switch-note">
          <strong>Note:</strong> You can switch back to your previous role at
          any time from the settings menu.
        </div>

        <div className="role-switch-actions">
          <button
            className="role-switch-button role-switch-button-cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="role-switch-button role-switch-button-confirm"
            onClick={onConfirm}
            disabled={isLoading}
            style={{ backgroundColor: getRoleColor(targetRole) }}
          >
            {isLoading ? (
              <span className="role-switch-spinner"></span>
            ) : (
              `Switch to ${getRoleDisplayName(targetRole)}`
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSwitchConfirmationModal;